// src/pages/inventory/rimender-stock/RimenderStockTableBody.jsx
import React from "react";
import { TableBody, TableRow, TableCell, Box } from "@mui/material";
import { formatNumber, formatText } from "../../../utils/formatters-master";

function RimenderStockTableBody({ data, page, rowsPerPage }) {
    return (
        <TableBody>
            {data
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                    // Tentukan warna untuk Kekurangan terhadap Stock
                    const kekuranganTerhadapStockColor = row.total_stock_pg4 < row.fc_berjalan ? '#f44336' : '#FFFFFF';
                    
                    // Tentukan warna untuk Status Stock terhadap Fc M1
                    const getStatusStockColor = (status) => {
                        switch(status) {
                            case 'Aman':
                                return '#4caf50'; // Hijau
                            case 'Warning':
                                return '#f44336'; // Merah
                            default:
                                return '#FFFFFF'; // Putih
                        }
                    };
                    
                    return (
                        <TableRow key={row.firebaseKey || index}>
                            {/* Group */}
                            <TableCell className="ded-tbtrtc">
                                <Box>
                                    <div style={{ fontWeight: "bold" }}>
                                        {formatText(row.kategori_material)}
                                    </div>
                                </Box>
                            </TableCell>

                            {/* Item Code */}
                            <TableCell>{formatText(row.kode_material)}</TableCell>

                            {/* Description */}
                            <TableCell>{formatText(row.nama_produk)}</TableCell>

                            {/* UoM */}
                            <TableCell>{formatText(row.uom)}</TableCell>
                            
                            {/* Fresh Pineapple - Forecast - M1 */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_M1)}</TableCell>

                            {/* Fresh Pineapple - Forecast - M2 */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_M2)}</TableCell>

                            {/* Fresh Pineapple - Forecast - M3 */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_M3)}</TableCell>

                            {/* Fresh Pineapple - Forecast - M4 */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_M4)}</TableCell>

                            {/* Fresh Pineapple - Forecast - M5 */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_M5)}</TableCell>

                            {/* Fresh Pineapple - Forecast - M6 */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_M6)}</TableCell>

                            {/* Fresh Pineapple - Forecast - Total Forecast */}
                            <TableCell>{formatNumber(row.forecast_fresh_pineapple_total)}</TableCell>

                            {/* Fresh Pineapple - Actual - Realisasi */}
                            <TableCell>{formatNumber(row.actual_fresh_pineapple)}</TableCell>

                            {/* Fresh Pineapple - Actual - FC Berjalan */}
                            <TableCell>{formatNumber(row.fc_berjalan_fresh_pineapple)}</TableCell>

                            {/* Fresh Pineapple - Actual - % Realisasi */}
                            <TableCell>{row.persen_realisasi_fresh_pineapple}%</TableCell>
                            
                            {/* Banana - Forecast - M1 */}
                            <TableCell>{formatNumber(row.forecast_banana_M1)}</TableCell>

                            {/* Banana - Forecast - M2 */}
                            <TableCell>{formatNumber(row.forecast_banana_M2)}</TableCell>

                            {/* Banana - Forecast - M3 */}
                            <TableCell>{formatNumber(row.forecast_banana_M3)}</TableCell>

                            {/* Banana - Forecast - M4 */}
                            <TableCell>{formatNumber(row.forecast_banana_M4)}</TableCell>

                            {/* Banana - Forecast - M5 */}
                            <TableCell>{formatNumber(row.forecast_banana_M5)}</TableCell>

                            {/* Banana - Forecast - M6 */}
                            <TableCell>{formatNumber(row.forecast_banana_M6)}</TableCell>

                            {/* Banana - Forecast - Total Forecast */}
                            <TableCell>{formatNumber(row.forecast_banana_total)}</TableCell>

                            {/* Banana - Actual - Realisasi */}
                            <TableCell>{formatNumber(row.actual_banana)}</TableCell>

                            {/* Banana - Actual - FC Berjalan */}
                            <TableCell>{formatNumber(row.fc_berjalan_banana)}</TableCell>

                            {/* Banana - Actual - % Realisasi */}
                            <TableCell>{row.persen_realisasi_banana}%</TableCell>
                            
                            {/* Other Fresh Fruits - Forecast - M1 */}
                            <TableCell>{formatNumber(row.forecast_other_M1)}</TableCell>

                            {/* Other Fresh Fruits - Forecast - M2 */}
                            <TableCell>{formatNumber(row.forecast_other_M2)}</TableCell>

                            {/* Other Fresh Fruits - Forecast - M3 */}
                            <TableCell>{formatNumber(row.forecast_other_M3)}</TableCell>

                            {/* Other Fresh Fruits - Forecast - Total Forecast */}
                            <TableCell>{formatNumber(row.forecast_other_total)}</TableCell>

                            {/* Other Fresh Fruits - Actual - Realisasi */}
                            <TableCell>{formatNumber(row.actual_other_fresh_fruits)}</TableCell>

                            {/* Other Fresh Fruits - Actual - FC Berjalan */}
                            <TableCell>{formatNumber(row.fc_berjalan_other)}</TableCell>

                            {/* Other Fresh Fruits - Actual - % Realisasi */}
                            <TableCell>{row.persen_realisasi_other}%</TableCell>
                            
                            {/* Total Forecast PG4 - Total Forecast */}
                            <TableCell>{formatNumber(row.total_forecast)}</TableCell>

                            {/* Total Forecast PG4 - Total Realisasi */}
                            <TableCell>{formatNumber(row.total_realisasi)}</TableCell>

                            {/* Total Forecast PG4 - FC Berjalan */}
                            <TableCell>{formatNumber(row.fc_berjalan)}</TableCell>

                            {/* Total Forecast PG4 - Kekurangan terhadap Stock - dengan warna dinamis */}
                            <TableCell sx={{ color: kekuranganTerhadapStockColor }}>
                                {formatNumber(row.kekurangan_terhadap_stock)}
                            </TableCell>
                            
                            {/* Stock PG4 - Warehouse BPP */}
                            <TableCell>{formatNumber(row.stock_warehouse_bpp)}</TableCell>

                            {/* Stock PG4 - Gd. Mixer Fresh Pine */}
                            <TableCell>{formatNumber(row.stock_gd_mixer_fresh_pine)}</TableCell>

                            {/* Stock PG4 - Gd. Mat. Banana */}
                            <TableCell>{formatNumber(row.stock_gd_mat_banana)}</TableCell>

                            {/* Stock PG4 - Gd. Mat. Other Fruits */}
                            <TableCell>{formatNumber(row.stock_gd_mat_other_fruits)}</TableCell>

                            {/* Stock PG4 - Quality Insp */}
                            <TableCell>{formatNumber(row.stock_quality_insp)}</TableCell>

                            {/* Stock PG4 - Transit and Transfer */}
                            <TableCell>{formatNumber(row.stock_transit_and_transfer)}</TableCell>

                            {/* Stock PG4 - Total Stock PG4 */}
                            <TableCell>{formatNumber(row.total_stock_pg4)}</TableCell>
                            
                            {/* Status Stock terhadap Fc M1 - dengan warna dinamis */}
                            <TableCell sx={{ color: getStatusStockColor(row.status_stock_terhadap_fc_m1) }}>
                                {row.status_stock_terhadap_fc_m1}
                            </TableCell>

                            {/* Safety Stock */}
                            {/*<TableCell>{formatNumber(row.safety_stock)}</TableCell>*/}

                            {/* Estimasi Kekurangan Stock Bulan Berjalan (M1) */}
                            <TableCell>{formatNumber(row.estimasi_kekurangan_m1)}</TableCell>

                            {/* Estimasi Kekurangan Stock terhadap Forecast (M2) */}
                            <TableCell>{formatNumber(row.estimasi_kekurangan_m2)}</TableCell>

                            {/* Estimasi Kekurangan Stock terhadap Forecast (M3) */}
                            <TableCell>{formatNumber(row.estimasi_kekurangan_m3)}</TableCell>
                        </TableRow>
                    );
                })}
        </TableBody>
    );
}

export default RimenderStockTableBody;